import React, { useState, useEffect } from "react";
import styles from "./styles.module.scss";

const LastFrame = (props) => {
  const { players, cardStyles } = props;
  const squares = new Array(4).fill("");
  const [higherFrame, setHigherFrame] = useState(0);
  const [turns, setTurns] = useState([]);
  const loggedInUser = localStorage.getItem("loggedInUser");
  const loggedInUserObj = loggedInUser && JSON.parse(loggedInUser);

  useEffect(() => {
    if (players && players.length) {
      setHigherFrame(0);
    }
  }, [players]);

  useEffect(() => {
    let arr = new Array(4).fill("");
    setTurns(
      arr.map((s, index) => {
        return higherFrame > 4 ? higherFrame - 3 + index : index + 1;
      })
    );
  }, [higherFrame]);

  const findLastScore = (array) => {
    if (array.length > higherFrame) {
      setHigherFrame(array.length);
    }
    return higherFrame > 4
      ? { indices: higherFrame - 4, values: array.slice(higherFrame - 4) }
      : { indices: 0, values: array };
  };

  const calculateCurrentSquare = (laneThrow) => {
    return (
      (laneThrow.throws &&
        Math.round(
          (((laneThrow.throws && laneThrow.throws.length) || 0) + 1) / 2
        )) ||
      1
    );
  };

  const {
    fontColor: throwsColor,
    fontSize: throwsFontSize,
    fontBold: throwsFontWeight,
  } = cardStyles.throwsStyle;

  const {
    fontColor: nameColor,
    fontSize: nameFontSize,
    fontBold: nameFontWeight,
    fontFamily: nameFontFamily,
  } = cardStyles.playerName;

  const {
    fontColor: scoreColor,
    fontSize: scoreFontSize,
    fontBold: scoreFontWeight,
  } = cardStyles.frameScore;

  const {
    lowFrameBackground: currentLowFrameBackground,
    topFrameBackground: currentTopFrameBackground,
  } = cardStyles.currentFrame;

  const someStyle = {
    "--throwsColor": throwsColor,
    "--throwsFontSize": throwsFontSize,
    "--throwsFontWeight": throwsFontWeight
      ? "700"
      : loggedInUserObj.accountType === "Freemium"
        ? "400"
        : "normal",
    "--nameColor": nameColor,
    "--nameFontSize": nameFontSize,
    "--nameFontWeight": nameFontWeight
      ? "700"
      : loggedInUserObj.accountType === "Freemium"
        ? "400"
        : "normal",
    "--nameFontFamily":
      loggedInUserObj.accountType === "Freemium"
        ? "Roboto Mono"
        : nameFontFamily,
    "--scoreColor": scoreColor,
    "--scoreFontSize": scoreFontSize,
    "--scoreFontWeight": scoreFontWeight
      ? "700"
      : loggedInUserObj.accountType === "Freemium"
        ? "400"
        : "normal",
    "--currentLowFrameBackground": currentLowFrameBackground,
    "--currentTopFrameBackground": currentTopFrameBackground,
    "--topFrameBackground": cardStyles.topFrameBackground,
    "--scoresContainerBackground": cardStyles.scoresContainerBackground,
    "--framesContainerBackground": cardStyles.framesContainerBackground,
    "--sectionContainerBackground": cardStyles.sectionContainerBackground,
    "--fontFamily":
      loggedInUserObj.accountType === "Freemium"
        ? "Roboto Mono"
        : "'Saira', sans-serif",
    "--turnFontWeight": "600",
  };

  return players && players.length ? (
    <div className={styles.playersCard} style={someStyle}>
      <div className={styles.headerCard}>
        <span>{`Game #${players.length && players[0].game}`}</span>
        <span>{`Lane ${players.length && players[0].lane}`}</span>
      </div>
      <div className={styles.bodyTable}>
        <div className={styles.turns}>
          {turns.map((e, index) => (
            <span className={styles.turn} key={index}>
              {e}
            </span>
          ))}
        </div>
        {players.map((laneThrow, ind) => {
          const { indices, values: lastScore } = findLastScore(
            laneThrow.scores
          );

          return (
            <div className={styles.players} key={ind}>
              <div className={styles.squares}>
                <span className={styles.playerName}>
                  {laneThrow.displayName || laneThrow.playerName}
                </span>
                {squares.map((e, index) => {
                  return (
                    <span
                      className={`${styles.square} ${styles.score} ${
                        laneThrow &&
                        laneThrow.throws.length > index * 2 &&
                        styles.past
                      } ${
                        indices + index + 1 ===
                          calculateCurrentSquare(laneThrow) && styles.current
                      }`}
                      key={index}
                    >
                      <span className={styles.numbers}>
                        <span className={styles.scoreNumber}>
                          {lastScore[index] || ""}
                        </span>
                      </span>
                    </span>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  ) : null;
};

export default LastFrame;
